module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/hanna-shyriaieva-avatar-83c9141a548a64f21e0e61f36de798d7.jpg";